import { useState, useEffect } from 'react';
import { Stack, PrimaryButton, Image, Text, TextField } from '@fluentui/react';
import {
    infoContainerStyle,
    callContainerStackTokens,
    configContainerStyle,
    configContainerStackTokens,
    containerStyle,
    containerTokens,
    headerStyle,
    teamsItemStyle,
    buttonStyle
  } from '../styles/HomeScreen.styles';
import { TeamsMeetingLinkLocator } from '@azure/communication-calling';
import { localStorageAvailable, getDisplayNameFromLocalStorage, saveDisplayNameToLocalStorage } from '../utils/localStorage';
import { DisplayNameField } from './DisplayNameField';
import { useMsal } from '@azure/msal-react';
import { useGlobalState } from '../utils/GlobalState';
import { ExaminerService } from '../services/examiner.service';

  export interface HomeScreenProps {
    startCallHandler(callDetails: { displayName: string; teamsLink?: TeamsMeetingLinkLocator }): void;
  }
  

  export const HomeScreen = (props: HomeScreenProps): JSX.Element => {    
    const { instance, accounts, inProgress } = useMsal();  
    const headerTitle = "Join Examination"
    const defaultDisplayName = localStorageAvailable ? getDisplayNameFromLocalStorage() : null;
    const [displayName, setDisplayName] = useState<string | undefined>(defaultDisplayName ?? (accounts[0].name ? accounts[0].name : accounts[0].username));
    const [teamsLink, setTeamsLink] = useState<TeamsMeetingLinkLocator>();
    const teamsCallChosen: boolean = false;    
    const { state } = useGlobalState();

    const buttonEnabled = displayName && (!teamsCallChosen || teamsLink) && state.examDetails?.courseName && state.accessToken && state.acsToken;
    
    return (
      <Stack
        horizontal
        wrap
        horizontalAlign="center"
        verticalAlign="center"
        tokens={containerTokens}
        className={containerStyle}
      >
        <Image alt="Welcome to the NESA Oral Examination App" src={require("../assets/Waratah.jpg")} />        
        <Stack className={infoContainerStyle}>                 
          <Text role={'heading'} aria-level={1} className={headerStyle}>
            {headerTitle}
          </Text>
          <Text role={'article'}>
            <strong>Course Name: </strong> {state.examDetails?.courseName} <br />
         
          </Text>
          <Stack className={configContainerStyle} tokens={configContainerStackTokens}>
          <Stack tokens={callContainerStackTokens}>
            {teamsCallChosen && (
              <TextField
                className={teamsItemStyle}
                iconProps={{ iconName: 'Link' }}
                placeholder={'Enter a Teams meeting link'}
                onChange={(_, newValue) => newValue && setTeamsLink({ meetingLink: newValue })}
              />
            )}
          </Stack>
            <DisplayNameField defaultName={displayName} setName={setDisplayName} disabled={true} />
            <PrimaryButton
            disabled={!buttonEnabled}
            className={buttonStyle}
            text="Join"
            onClick={() => {
              if (displayName) {
                setTeamsLink({meetingLink: state.meetingId!});
                saveDisplayNameToLocalStorage(displayName);
                props.startCallHandler({ displayName, teamsLink });
              }
            }} />
                       
          </Stack>          
        </Stack>
      </Stack>
    );
};